export default {
    nl: {
        intro: {
            subtitle: 'Laravel',
            title: 'Laravel certified company.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/laravel/hero.jpg',
        },
        type: 'Laravel',
        title: 'Laravel Expertise: Van MVP tot enterprise webapplicaties',
        description:
            'Laravel: snel, flexibel & krachtig. Als Laravel Certified Company optimaliseren we je webontwikkeling met topfuncties en innovaties.',
        content: [
            {
                type: 'text',
                title: 'Laravel',
                content: `
                    Als trendsetter in de digitale wereld zijn we trots op onze expertise in Laravel, een van de meest begeerde PHP frameworks. De meeste van onze developers zijn al Certified Laravel Developer, maar daar komt een nieuwtje bij. We zijn namelijk niet alleen deskundig op individueel niveau maar dragen als bedrijf nu ook de eer om een Laravel Certified Company te zijn.
                    <br><br>
                    Laravel is ons go-to framework. Dankzij Laravel kunnen we snel webapplicaties bouwen zonder in te leveren op kwaliteit - van minimum viable product (MVP) tot volledig enterprise product. Onze developers dragen actief bij aan de Laravel community en zorgen ervoor altijd op de hoogte te zijn van de nieuwste innovaties.
                `,
            },
            {
                type: 'text',
                title: 'Waarom Laravel?',
                content: `
                    Laravel draait goed op zowel kleine servers als grote netwerken. Dit dynamische framework groeit naadloos mee met de behoeften van de klant. De ontwikkeling wordt versterkt door een gebruiksvriendelijke command-line interface en het maakt gebruik van object-relational mapping (ORM). Dit vereenvoudigt data-opvragingen en -bewerkingen. Als open-source tool is Laravel snel op te pakken dankzij zijn uitgebreide documentatie.
                    <br><br>
                    De schaalbaarheid van Laravel wordt verder benadrukt door zijn eenvoudig onderhoudbare codebases. Met het modulaire packagingsysteem en solide dependencybeheer, kun je nieuwe functies aan je toepassingen toevoegen zonder enige hinder.
                `,
            },
            {
                type: 'quote',
                content:
                    'Dankzij Laravel kunnen we snel webapplicaties bouwen zonder in te leveren op kwaliteit',
            },
            {
                type: 'text',
                title: 'De voordelen van Laravel',
                content: `
                    Al met al is Laravel een krachtig framework met tal van voordelen voor het bouwen van web toepassingen en het vereenvoudigen van het ontwikkelproces. In aanvulling op de krachtige kernfuncties van Laravel, integreren we ook naadloos met API's om de functionaliteit en connectiviteit van onze webapplicaties te vergroten. Door de combinatie van onze kennis en kunde met andere diensten, zoals front-end development en back-end development, garanderen we een gestroomlijnd ontwikkelproces voor elke klant.
                `,
            },
            {
                type: 'laravel-certified',
                title: 'Laravel certified company',
                content: `
                    Bij  23G zijn we trots op onze <a href="https://www.certificationforlaravel.com/companies/23g" target="_blank" rel="noreferrer">Laravel-certificering</a>, wat betekent dat we hoogwaardige ontwikkeling bieden met gecertificeerde Laravel-ontwikkelaars. Ons team staat garant voor kwaliteitscode, klantgericht ontwikkelingsproces en blijft up-to-date met de nieuwste Laravel-technologie.
                    <br><br>
                    Daarnaast zijn we lid van de <a href="https://dutchlaravelfoundation.nl/leden/23g" target="_blank" rel="noreferrer">Dutch Laravel Foundation</a>. Dit is dé kennis- en brancheorganisatie voor Laravel-ontwikkelaars. We wisselen kennis uit en ontmoeten elkaar tijdens evenementen.
                `,
            },
            {
                type: 'case',
                case: 'nines',
            },
        ],
        related_services: ['design-sprint', 'strategy-session', 'client-portal'],
        contact: {
            title: '',
            employee: 'tobias',
        },
    },
    en: {},
};
